module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ashou5-607f132b8780cf2a0a241d35c18d25ab.jpg";